import styled from 'styled-components';
import { Typography } from '@mui/material';
import { ReactComponent as MascotIcon } from '../../../assets/ai-mascot.svg';
import { FlexCenter, FlexColumn } from '../../Flex';
import { fontSize, space } from '../../../style/utils';

const Wrapper = styled(FlexColumn)<{ $maxWidth?: number }>`
  width: 100%;
  align-items: center;
  gap: ${space('lg')};
  padding: ${space(0, 'xxxl')};
  max-width: ${({ $maxWidth }) => ($maxWidth ? `${$maxWidth}px` : 'none')};
  align-self: center;
  flex-shrink: 0;
`;

const MascotWrapper = styled(FlexCenter)`
  width: 48px;
  height: 64px;

  svg {
    width: 100%;
    height: 100%;
  }
`;

const Title = styled(Typography)<{ $isExpanded?: boolean }>`
  color: ${({ theme }) => theme.palette.content.primary};
  font-size: ${({ $isExpanded }) =>
    $isExpanded ? fontSize('xl') : fontSize('base')};
  line-height: normal;
  font-weight: ${({ theme }) => theme.typography.fontWeightRegular};
  text-align: center;
  max-width: 320px;
`;

type Props = {
  title: string;
  maxWidth?: number;
};

const EmptyState = ({ title, maxWidth }: Props) => (
  <Wrapper $maxWidth={maxWidth}>
    <MascotWrapper>
      <MascotIcon />
    </MascotWrapper>
    <Title $isExpanded={!!maxWidth}>{title}</Title>
  </Wrapper>
);

export default EmptyState;
